import { useFormBuilderStore } from '@/stores/formBuilderStore'
import { AppearanceMainPreview } from './AppearanceMainPreview'

type BuilderMainPreviewContext = 'question' | 'appearance' | 'binding' | 'logic'

type BuilderMainPreviewProps = {
  context?: BuilderMainPreviewContext
  variant?: 'full' | 'inline'
  onOpenFullPreview?: () => void
}

const previewCopy: Record<
  BuilderMainPreviewContext,
  {
    title: string
    description: string | null
  }
> = {
  question: {
    title: '問題編輯即時預覽',
    description: null,
  },
  appearance: {
    title: '外觀設定即時預覽',
    description: '主題、字體、佈局與品牌設定會直接套用到填答畫面。',
  },
  binding: {
    title: '欄位綁定即時預覽',
    description: '設定新客申請欄位時，中央畫面保留填答者實際看到的題目效果。',
  },
  logic: {
    title: '邏輯規則即時預覽',
    description: '規劃跳題條件時，也能確認目前問題在填答流程中的呈現方式。',
  },
}

export function BuilderMainPreview({
  context,
  variant = 'full',
}: BuilderMainPreviewProps) {
  const activeTab = useFormBuilderStore((state) => state.activeTab)
  const previewContext = context ?? activeTab
  const copy = previewCopy[previewContext]

  return (
    <AppearanceMainPreview
      variant={variant}
      title={copy.title}
      description={copy.description}
    />
  )
}
